import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

class CallOutcome extends React.Component {

  onSelect = (value) => {
    this.props.onSelect(value)
  }

  getCallOutcomeName = (call_outcome) => {
    let call_outcome_name = call_outcome || ''
    return call_outcome_name.replace(/\_/g, ' ')
  }

  render() {
    let currentName = this.getCallOutcomeName(this.props.call_outcome || 'Call Outcome')

    const call_outcomes = [
      'No answer',
      'Answered but wants to be called later',
      'Answered and had sales conversation',
      'SDR takeover for Whatsapp conversation'
    ]

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm">
            {currentName} <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {_.map(call_outcomes, (call_outcome) => {
            let name = this.getCallOutcomeName(call_outcome)

            return (
              <CallOutcomeOption
                key={call_outcome}
                name={name}
                value={call_outcome}
                onSelect={this.onSelect} />
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

class CallOutcomeOption extends React.Component {

  onSelect = () => {
    this.props.onSelect(this.props.value)
  }

  render() {
    return (
      <DropdownMenuItem onSelect={this.onSelect}>{this.props.name}</DropdownMenuItem>
    )
  }
}

export default CallOutcome
